<template>
  <div class="video-player-container">
    <div class="video-title">{{ title }}</div>

    <Vue3VideoPlay
      v-if="options.src"
      v-bind="options"
      :poster="defaultPoster"
    />
    <div v-if="options.src" class="video-title-bottom">{{ title }}</div>
  
    <!--:options="options" -->
    <div v-else>未找到视频资源</div>    
    <div class="actions"><button class="back-btn" @click="goBack">返回</button></div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import { computed, reactive, watch } from 'vue'
import Vue3VideoPlay from 'vue3-video-play'
import 'vue3-video-play/dist/style.css'

const router = useRouter()
const route = useRoute()

const videoUrl = computed(() => route.query.url || '')
const title = computed(() => route.query.title || '视频播放')


const defaultPoster = '/videoimg.jpg'
const options = reactive({
  width: "100%",
  height: "600px",
  color: "#409eff",
  title: title.value,
  src: "",
  muted: false,
  webFullScreen: false,
  speedRate: ["0.5", "0.75", "1.0", "1.25", "1.5", "2.0"],
  autoPlay: false,
  loop: false,
  mirror: false,
  ligthOff: false,
  volume: 0.3,
  control: true,
  controlBtns: [
    "audioTrack", "quality", "speedRate", "volume",
    "setting", "pip", "pageFullScreen", "fullScreen"
  ],
})

// ✅ 监听 url 变化
watch(videoUrl, (newUrl) => {
  if (newUrl) {
    options.src = decodeURIComponent(newUrl) // 解码
    options.title = title.value
  }
}, { immediate: true })

function goBack() {
  router.back()
}

</script>

<style scoped>
.video-player-container {
  text-align: center;
  padding: 20px;
}

/* .actions {
  text-align: center;
  margin-top: 16px;
} */
.actions {
  text-align: center;   /* 内部文字/行内元素居中 */
  margin-top: 16px;
  margin-left: 1100px;    /* 利用 auto margin 让元素靠右 */
  width: 200px;         /* 需指定宽度（或用 inline-block 适应内容） */
}
.back-btn {
  padding: 8px 16px;
  font-size: 14px;
  color: #fff;
  background-color: #409eff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.back-btn:hover {
  background-color: #337ecc;
}
.video-title-bottom {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
}
</style>